export function slugify(text) {
  if (!text) return "";

  let slug = text.toString().toLowerCase();

  // 1. Umlaute und Sonderzeichen umwandeln (Deutsch)
  slug = slug
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss");

  // 2. Standard-Slug-Bereinigung
  slug = slug
    .replace(/\s+/g, "-") // Leerzeichen durch Bindestriche ersetzen
    .replace(/[^\w\-]+/g, "") // Nicht-Wort-Zeichen (außer Bindestriche) entfernen
    .replace(/\-\-+/g, "-") // Mehrere Bindestriche durch einen ersetzen
    .replace(/^-+/, "") // Führende Bindestriche entfernen
    .replace(/-+$/, ""); // Nachfolgende Bindestriche entfernen

  return slug;
}
